import { trackWhatsAppClick } from "@/lib/tracking";

export const WHATSAPP_NUMBERS = ["601168115078", "601167707273"];

export const WHATSAPP_MESSAGE =
  "Hi EY 58 Group, saya ingin membuat semakan awal mengenai pembiayaan. Boleh bantu saya?";

const RR_KEY = "ey58_wa_rr";

export const buildWaLink = (number, message = WHATSAPP_MESSAGE) =>
  `https://wa.me/${number}?text=${encodeURIComponent(message)}`;

// Round-robin 共享计数器：所有 CTA 点击时统一取用并推进，
// 持久化到 localStorage，保证跨按钮、跨页面刷新分流依然平均。
export const nextWhatsAppTarget = () => {
  let idx = 0;
  try {
    const stored = parseInt(window.localStorage.getItem(RR_KEY) || "0", 10);
    idx = Number.isNaN(stored) ? 0 : stored;
  } catch (e) {
    idx = 0;
  }
  const number = WHATSAPP_NUMBERS[idx % WHATSAPP_NUMBERS.length];
  try {
    window.localStorage.setItem(
      RR_KEY,
      String((idx + 1) % WHATSAPP_NUMBERS.length),
    );
  } catch (e) {}
  return { number, url: buildWaLink(number) };
};

export const openWhatsApp = (location) => {
  const { number, url } = nextWhatsAppTarget();
  trackWhatsAppClick(location, number);
  window.open(url, "_blank", "noopener,noreferrer");
};
